module.exports = require('./syntax');